
interface CategoryListProps {
  selectedCategory: string;
  onCategorySelect: (category: string) => void;
}

const categories = [
  {
    id: 'all',
    name: 'All Discussions',
    icon: 'ri-discuss-line',
    count: 156,
    color: 'text-gray-600'
  },
  {
    id: 'sessions',
    name: 'Sessions',
    icon: 'ri-headphone-line',
    count: 42,
    color: 'text-green-600',
    description: 'Share and discuss listening sessions'
  },
  {
    id: 'music-discovery',
    name: 'Music Discovery',
    icon: 'ri-music-2-line',
    count: 38,
    color: 'text-emerald-600',
    description: 'Discover new artists and tracks'
  },
  {
    id: 'equipment',
    name: 'Equipment',
    icon: 'ri-equalizer-line',
    count: 29,
    color: 'text-teal-600',
    description: 'Audio gear and setup discussions'
  },
  {
    id: 'community',
    name: 'Community',
    icon: 'ri-group-line',
    count: 47,
    color: 'text-cyan-600',
    description: 'General community discussions'
  }
];

export default function CategoryList({ selectedCategory, onCategorySelect }: CategoryListProps) {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-green-100 p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-4">Categories</h2>
      
      <div className="space-y-2">
        {categories.map((category) => (
          <button
            key={category.id}
            onClick={() => onCategorySelect(category.id)}
            className={`w-full text-left p-3 rounded-lg transition-all duration-200 cursor-pointer ${
              selectedCategory === category.id
                ? 'bg-gradient-to-r from-green-50 to-emerald-50 border border-green-200'
                : 'hover:bg-gray-50'
            }`}
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className={`w-8 h-8 flex items-center justify-center ${category.color}`}>
                  <i className={`${category.icon} text-lg`}></i>
                </div>
                <div>
                  <div className="font-medium text-gray-900 text-sm">{category.name}</div>
                  {category.description && (
                    <div className="text-xs text-gray-500 mt-1">{category.description}</div>
                  )}
                </div>
              </div>
              <span className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded-full">
                {category.count}
              </span>
            </div>
          </button>
        ))}
      </div>

      {/* Quick Stats */}
      <div className="mt-6 pt-6 border-t border-gray-100">
        <h3 className="text-sm font-medium text-gray-900 mb-3">Quick Stats</h3>
        <div className="space-y-2 text-sm">
          <div className="flex justify-between">
            <span className="text-gray-600">Active Users</span>
            <span className="font-medium text-green-600">1,247</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Today's Posts</span>
            <span className="font-medium text-emerald-600">23</span>
          </div>
          <div className="flex justify-between">
            <span className="text-gray-600">Online Now</span>
            <span className="font-medium text-teal-600">89</span>
          </div>
        </div>
      </div>
    </div>
  );
}
